<template>
  <div class="loginPage">
    <!-- header start -->
    <van-nav-bar
      title="验证手机号"
      class="mynavbar"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <!-- header end -->
    <img src="@/assets/images/login/register.jpg" class="loginBg" />
    <div class="block pwd-block">
      <div>
        <div class="field-item">
          <div class="hd"><div class="label">账号</div></div>
          <div class="bd">
            <van-field v-model="input.phone" placeholder="手机号码" />
          </div>
        </div>
        <div class="field-item">
          <div class="hd"><div class="label">验证码</div></div>
          <div class="bd">
            <van-field
              type="number"
              v-model="input.code"
              placeholder="请输入手机验证码"
            />
          </div>
        </div>
        <p class="sendCodeLine">
          <!-- <span class="sendCodeBtn">获取验证码</span> -->
          <van-button
            @click="sendRegisterSmsCode"
            :disabled="disabled"
            slot="button"
            size="small"
            type="info"
            class="sendCodeBtn"
            >{{ downText }}</van-button
          >
        </p>
        <div class="btn-area">
          <van-button round class="loginbtn" @click="goAuthPhone"
            >确定</van-button
          >
          <!-- to="/FindPwd" -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import common from "../../tools/common.js";

export default {
  data() {
    return {
      returnUrl:"User",
      code: "",
      input: {
        code: "",
        phone: "",
        type:"MemberPhoneAuthPost"
      },
      downText: "获取验证码",
      second: 60,
      disabled: false,
    };
  },
  components: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    init() {
      this.refreshCode();
    },
    sendRegisterSmsCode() {
      var that = this;
      if (that.input.phone.length <= 0) {
        Toast("手机号不能为空！");
        return false;
      }
      var myreg = /^[1][0-9]{10}$/;
      if (!myreg.test(that.input.phone)) {
        Toast("请输入正常的手机号");
        return false;
      }
      // Object.assign(that.inputText, {
      //   type: "SendRegisterSmsCode"
      // });
      that.$store
        .dispatch({
          type: "SendRegisterSmsCodeVue",
          Phone: that.input.phone,
        })
        .then(
          (res) => {
            if (!res.Result.IsSuccess) {
              Toast(res.Result.Message);
            } else {
              common.countdowm(that, that.input.phone, that.second);
            }
            // if (res.IsSuccess) {
            //   common.countdowm(that, that.inputText.Phone, that.second);
            //   Toast(res.Message);
            // } else {
            //   Toast(res.Message);
            // }
          },
          (err) => {}
        );
    },
    refreshCode() {
      var that = this;
      this.$store.dispatch({ type: "GetRandomNum" }).then(
        (res) => {
          that.code = "";
          if (res.Result.IsSuccess) {
            that.code = res.Result.Message;
          }
        },
        (err) => {}
      );
    },
    goAuthPhone() {
      var that = this;
      var regPhone = /^1[0-9]{10}$/;
      if (that.input.phone == "") {
        Toast("手机号码不能空！");
        return false;
      } else if (!regPhone.test(that.input.phone)) {
        Toast("手机号码不正确，请核对后再输入！");
        return false;
      }
      if (that.input.code == "") {
        Toast("手机验证码不能为空！");
        return false;
      }
      that.$store
        .dispatch(this.input)
        .then((res) => {
          //console.log(res,"goAuthPhone");
          Toast(res.Message);
          if(!res.IsSuccess){
            
          }else{
              //that.$router.replace({ name:this.returnUrl });
              location.href=this.returnUrl;
          }
          
        });

    },
  },
  created() {
    this.returnUrl= this.$route.query.ReturnUrl;
    this.init();
  },
};
</script>

<style scoped>
.pwd-block {
  margin-top: 20%;
}
.changeCode {
  margin-left: 20px;
  padding: 10px;
  font-size: 12px;
  color: orange;
}
.codePic {
  display: block;
  width: 64px;
  height: 28px;
}
.sendCodeLine {
  text-align: center;
  margin-top: 6%;
  margin-bottom: 20%;
}
.sendCodeBtn {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  padding: 0 20px;
  font-size: 12px;
  color: #fff;
  border-radius: 40px;
  background-color: rgba(255, 255, 255, 0.3);
}
</style>
